import React, { Component } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

import Header from "../Components/Header";
import Button, { icons } from "../Components/Button";
import { API_URL } from '../Config';
import { parseHash } from '../Url';

const Location = styled.li`
  margin-bottom: 2rem;
  color: #999;
  `;

const Status = styled.span`
  display: inline-block;
  width: .6rem;
  height: .6rem;
  background-color: ${({ isActive }) => isActive ? `#00d800` : `red`};
  border-radius: .3rem;
  margin-right: 1rem;
  `

const Zone = styled(Link)`
  display: flex;
  align-items: center;
  padding: 1.5rem 0;
  border: none;
  text-align: left;
  font-size: inherit;
  cursor: pointer;
  border-bottom: 1px solid #ccc;
`;

const Arrow = styled.div`

  width: 20px;
  height: 20px;

  svg {
    width: 100%;
    height: 100%;
  }
`

export default class Locations extends Component {
  constructor(props) {
    super(props);

    this.state = {
      locations: window.persistence.local.get("locations") || {}
    };
  }

  componentWillMount() {
    let params = parseHash()
    if (params.code) {
      const newZone = this.findExistingZone(params.code)
      if (!newZone) {
        this.props.history.push(`/add#code=${params.code}`);
        return
      }
      this.props.setCurrentZone(newZone)
      this.props.history.push('/player');
    }
    if (Object.keys(this.state.locations).length === 0) {
      this.props.history.push('/add');
    }
  }

  findExistingZone(code) {
    for (let k in this.state.locations) {
      let location = this.state.locations[k]
      for (let i = 0; i < location.zones.length; i++) {
        let zone = location.zones[i]
        if (zone.remoteCode === code) {
          return zone
        }
      }
    }
    return null
  }

  handleZoneClick(e, zone) {
    if (zone.isPaired) {
      this.props.setCurrentZone(zone)
    } else {
      e.preventDefault();
      alert(`Zone "${zone.name}" has no connected player.`)
    }
  }

  componentDidMount() {
    this.promisedLocations = [];

    Object.keys(this.state.locations).forEach(location => {
      this.state.locations[location].zones.forEach(zone => {
        this.promisedLocations.push(
          fetch(`${API_URL}/zone?token=${zone.token}`)
        );
      });
    });
    Promise.all(this.promisedLocations)
      .then(players => Promise.all(players.map(res => res.json())))
      .then(players => {
        players.forEach(player => {
          let locations = { ...this.state.locations }
          Object.keys(locations).forEach(location => {
            locations[location].zones.forEach((zone, i) => {
              if (zone.remoteCode === player.remoteCode) {
                locations[location].zones[i].playFrom =
                  player.nowPlaying.playFrom;
                locations[location].zones[i].isPaired =
                  player.isPaired;
                window.persistence.local
                  .set("locations", locations)
                  .thenUpdate();
              }
            });
          });
        });
      });
  }

  render() {
    if (!this.state.locations) {
      return <div />;
    };

    return (
      <div>
        <Header
          title="Locations"
          rightComponent={
            <Button icon="add" style={{ marginRight: '2rem' }} onClick={() => this.props.history.push("/add")} />
          }
        />
        <div style={{ width: '90%', margin: '0 auto', borderTop: '1px solid #ccc' }}>
          {this.state.locations && (
            <ul style={{ padding: '0 2rem' }}>
              {Object.keys(this.state.locations).map((location, i) => {
                return (
                  <Location key={i}>
                    <div style={{ borderBottom: '1px solid #ccc', paddingTop: '2rem', paddingBottom: '1rem', paddingLeft: '1rem' }}>
                      <p style={{ fontSize: '14px', marginBottom: '.5rem' }}>
                        {this.state.locations[location].zones[0].location.city},{" "}
                        {
                          this.state.locations[location].zones[0].location
                            .address
                        }
                      </p>
                      <h3 className="book" style={{ fontSize: '20px' }}>{location}</h3>
                    </div>
                    <ul>
                      {this.state.locations[location].zones.map((zone, i) => {
                        return (
                          <li key={`zone-${i}`}>
                            <Zone
                              onClick={(e) => this.handleZoneClick(e, zone)}
                              to={"/player"}
                            >
                              <Status isActive={zone.isPaired} />
                              <span style={{ flex: 1 }}>
                                <span style={{ color: '#000', fontSize: '20px', paddingRight: '1rem' }}>{zone.name} </span><span style={{ fontSize: '14px', color: '#999' }}>{zone.playFrom && zone.playFrom.name}</span>
                              </span>
                              {zone.isPaired && <Arrow>{icons['chevron-right']}</Arrow>}
                            </Zone>
                          </li>
                        )
                      })}
                    </ul>
                  </Location>
                );
              })}
            </ul>
          )}
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <a href="https://help.soundtrackbusiness.com/" target="_blank" className="bold" style={{ fontSize: '14px', color: '#999', padding: '1rem' }}>Need Help?</a>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Views/Locations.js